<template>
<div class="son-box">
    <div class="top-box" style="margin-top: -1rem;">
        <div style="display:flex;justify-content:space-between;align-items: center;height: .8rem;">
            <p style="color:#fff">x</p>
            <p style="">选择收货地址</p>
            <van-icon @click="closeAddress" name="cross" size=".3rem" style="padding-right:.2rem"/>
        </div>
      </div>
    <div style="margin-top:1rem">
        <div v-for="(item,index) in addressinfo" :key="index">
            <div class="add-box">
                <div style="display:flex;align-items: center;">
                    <div @click="adressChecked(item)" style="margin-right:.2rem">
                        <van-radio-group v-model="radioAddress">
                            <van-radio :name="item.id" checked-color="#ff355c"></van-radio>
                        </van-radio-group>
                    </div>
                    <div style="margin:0 .2rem">
                        <span>{{item.address_name}}</span>&nbsp;&nbsp;&nbsp;
                        <span>{{item.phone}}</span>
                        <span v-if="item.is_default == 1" class="default">默认</span>
                        <p class="address-info">{{item.site_info}}</p>
                    </div>
                </div>
                <div>
                    <van-icon @click="onEdit(item)" name="edit" style="font-size:.26rem"/>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import localStor from '../../utils/ls'
import {isAddressId} from '../../utils/addressId'
import { getAddressinfo } from '../../utils/fun'
export default {
    props:['address'],
    data(){
        return{
            addressinfo:[],
            radio:'0',
            isEdit:false,
            queryIds:'6',
            radioAddress:'',
        }
    },
    mounted(){
       this.getAddress() 
    },
    methods:{
        closeAddress(){
            this.$emit('closeAddress')
        },
        getAddress() {
            getAddressinfo({
                callBack:(data)=>{
                    this.addressinfo = data
                    let checkId = isAddressId.fetch()
                    this.radioAddress = parseInt(checkId) || this.addressinfo[0].id
                }
            })
        },
        adressChecked(item){
            this.$emit('addressItem',item)
        },  
        onEdit(item) {
            if (item.id) {
                localStor.save("dataEdit", item);
                this.isEdit = true;
            } else {
                this.isEdit = false;
            }
            this.$router.replace({
                name: "ShopAddress",
                params: { isEdit: this.isEdit, queryId:6,addressList:item }
            });
        },
    }
}
</script>
<style scoped>
  .son-box{
    margin-bottom: 1rem;
  }
  .add-box{
    background: #fff;
    margin: .2rem;
    padding: .2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
  }
  .address-info{
    margin-top: .2rem;
    line-height: .35rem;
    color: #C3C3C3;
  }
  .default{
    background: #ff355c;
    color: #fff;
    padding: .1rem .25rem .05rem;
    border-radius: .3rem;
    font-size: .22rem;
    margin-left: .2rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/address/Address.vue